// import "bootstrap/dist/css/bootstrap.min.css";
import { useContext } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../Contexts/UserContext";
import { useStaticPageContent } from "../../hooks/useStaticPageContent";
import { staticContentDefaults } from "../../data/staticContentDefaults";
import CmsRichText from "../common/CmsRichText";
import { mergeThanksHeadingHtml } from "../../utils/cmsHeadingUtils";

const ThankYouPage = () => {
  const navigate = useNavigate();
  const pageContent = useStaticPageContent("thanks");
  const content =
    pageContent?.headingHighlight
      ? pageContent
      : staticContentDefaults.thanks;

  const {expiryTiming,setExpiryTiming}= useContext(UserContext)
  //setExpiryTiming(0)

 // setExpiryTiming(null)
  const handleHomeButton = () => {
    navigate(content.ctaTarget || "/");
  };
  return (
    <section className="thank-you-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <div className="thank-you-page-content">
              <h1>
                <CmsRichText as="span" value={mergeThanksHeadingHtml(content)} />
              </h1>
              <a
                href="#"
                className="btn btn-primary arrow-icon"
                onClick={() => handleHomeButton()}
              >
                {" "}
                <CmsRichText as="span" value={content.ctaText} />{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThankYouPage;
